import { useEffect, useLayoutEffect } from 'react';

// Synchronously readable gates (cookies, frontend-config) must be applied before the browser
// paints, or the initial `false` renders and the chrome visibly shifts. useLayoutEffect does
// that; useEffect does not. Falls back to useEffect on the server, where neither runs and
// useLayoutEffect would warn.
export const useIsomorphicLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;

export default useIsomorphicLayoutEffect;
